export default "__VITE_ASSET__CIzr$Cks__"